import { useCallback } from 'react';

import type { PricingEntryPoint } from '@/shared/lib/pricingAttribution';

import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import type { BookSalesDemoSource } from '../lib/sources';

import { useBookSalesDemoStore } from './useBookSalesDemoStore';

export const useOpenBookSalesDemo = () => {
  const open = useBookSalesDemoStore((state) => state.open);

  return useCallback(
    (source: BookSalesDemoSource, sourceText: string, pricingEntryPoint?: PricingEntryPoint) => {
      MixpanelEvents.bookSalesDemoOpened({
        source,
        sourceText,
        ...(pricingEntryPoint ? { pricing_entry_point: pricingEntryPoint } : {}),
      });
      open({ source, sourceText });
    },
    [open],
  );
};
